import styled from 'styled-components';

const StatsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 1.5rem;
  gap: 0.75rem;
`;

export default StatsContainer;
